// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"e4b7b2a6","224":"3f56402c","361":"6e719510","568":"413afd7e","573":"b45a7d58","673":"6ad91348"}[chunkId] + ".chunk.js";
};